import React from 'react';
import { Link } from 'react-router-dom';

const LandingPage = ({ user }: any) => {
  return (
    <div className="landing-container">
      <section className="hero">
        <div className="hero-content">
          <h1 className="hero-title">Starlit Grimoire</h1>
          <p className="hero-subtitle">
            A celestial sanctuary for the modern practitioner. 
            Manage your spiritual journey in private, and share your wisdom with the collective.
          </p>
          <div className="hero-btns">
            {user ? (
              <Link to="/journal" className="btn-primary">Enter Your Journal</Link>
            ) : (
              <Link to="/auth" className="btn-primary">Join the Circle</Link>
            )}
          </div>
        </div>
        <div className="hero-overlay"></div>
      </section>

      <section className="features-overview content">
        <h2 className="section-title">The Practitioner's Toolkit</h2>
        <div className="grid">
          <div className="card feature-card">
            <div className="feature-icon">📓</div>
            <h3>Private Journal</h3>
            <p>A secure space for daily reflections, automatically tagged with current lunar phases.</p>
          </div>
          <div className="card feature-card">
            <div className="feature-icon">✨</div>
            <h3>Spell Tracker</h3>
            <p>Document your rituals, track ingredients, and log outcomes to refine your craft over time.</p>
          </div>
          <div className="card feature-card">
            <div className="feature-icon">🔮</div>
            <h3>Tarot Sanctuary</h3>
            <p>Perform digital readings with our integrated Tarot Reader, featuring deep lore and journal integration.</p>
          </div>
          <div className="card feature-card">
            <div className="feature-icon">📜</div>
            <h3>Reference Library</h3>
            <p>Access thousands of entries on gems, herbs, and deities. Build your own notes and learn from the community.</p>
          </div>
        </div>
      </section>

      <section className="community-cta">
        <div className="card content" style={{ textAlign: 'center', background: 'linear-gradient(rgba(45, 27, 77, 0.9), rgba(26, 11, 46, 0.9))' }}>
          <h2 style={{ color: 'var(--gold)' }}>The Community Circle</h2>
          <p style={{ maxWidth: '800px', margin: '1rem auto' }}>
            Share your successful spells and grimoire entries with fellow practitioners. 
            Ask questions in the forum, exchange messages, and grow together.
          </p>
          {!user ? (
            <Link to="/auth" className="btn-secondary" style={{ display: 'inline-block', marginTop: '1rem' }}>Create Your Account</Link>
          ) : (
            <Link to="/public" className="btn-secondary" style={{ display: 'inline-block', marginTop: '1rem' }}>Visit the Public Square</Link>
          )}
        </div>
      </section>

      <footer className="landing-footer">
        <p>&copy; 2026 Starlit Grimoire. All paths are valid.</p>
      </footer>
    </div>
  );
};

export default LandingPage;
